import React from 'react';
import { useIntl } from 'react-intl';

import { TranslateMessage } from '@xarvio/utils';
import { Button } from '@xarvio/button';
import { Modal, ModalContent, ModalFooter } from '@xarvio/modal';

import styles from './UsaTermsAndConditionsModal.module.scss';

interface Props {
  onClose: () => void;
}

export const UsaTermsAndConditionsModal: React.FC<
  React.PropsWithChildren<Props>
> = ({ onClose }) => {
  const intl = useIntl();

  const contentTranslation = intl.formatMessage({
    id: 'component.UsaTermsAndConditionsModal.content',
  });
  const titleTranslation = intl.formatMessage({
    id: 'component.UsaTermsAndConditionsModal.title',
  });

  return (
    <Modal
      onClose={onClose}
      panelSize="m"
      title={<span className={styles.logo}>xarvio</span>}
    >
      <ModalContent>
        <div
          className={styles.title}
          dangerouslySetInnerHTML={{
            __html: titleTranslation,
          }}
        />
        <div
          className={styles.container}
          dangerouslySetInnerHTML={{
            __html: contentTranslation,
          }}
        />
      </ModalContent>

      <ModalFooter>
        <Button
          onClick={onClose}
          type="primary"
          size="medium"
          label={<TranslateMessage id="general.cancel" />}
          blur
          width="200px"
        />
        <Button
          onClick={onClose}
          type="primary"
          size="medium"
          label={
            <TranslateMessage id="component.UsaTermsAndConditionsModal.accept" />
          }
          width="200px"
        />
      </ModalFooter>
    </Modal>
  );
};
